import { getApp, getApps, initializeApp } from 'firebase/app';

import { getFirebaseConfig } from './config';

export function getFirebaseApp() {
  return getApps().length > 0 ? getApp() : initializeApp(getFirebaseConfig());
}
